module.exports = __webpack_public_path__ + "static/dotted-circle.0375578c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/decorations/dotted-circle.png
// module id = 2276
// module chunks = 168707334958949